import { Route, Routes, Navigate } from "react-router-dom"
import AuthPage from "./auth/AuthPage"
import { Dashboard } from "./views/Dashboard"
import { PasswordChangeDialog } from "./views/PasswordChangeDialog"
import { AdminSettingsDialog } from "./views/AdminSettingsDialog"
import { WhatsNewDialog } from "./views/WhatsNewDialog"
import { AcceptInvitation } from "./views/AcceptInvitation"
import { PublicReportView } from "./views/PublicReportView"
import { useAuth } from "./auth/AuthProvider"
import "@fontsource/montserrat"
import NoAuth from "./NoAuth"

function Routing() {
  const { user } = useAuth()

  return (
    <Routes>
      {/* Auth routes - redirect to home if already authenticated */}
      <Route
        path="/auth/:pathname"
        element={
          user ? (
            <Navigate to="/" replace />
          ) : (
            <NoAuth>
              <AuthPage />
            </NoAuth>
          )
        }
      />

      {/* Invitation acceptance - accessible to all users (authenticated and unauthenticated) */}
      <Route
        path="/invitation/:invitationId"
        element={
          <NoAuth>
            <AcceptInvitation />
          </NoAuth>
        }
      />

      {/* Public login-free report - no auth, no MainLayout, no section Selection wrapper */}
      <Route
        path="/share/:shareToken"
        element={
          <NoAuth>
            <PublicReportView />
          </NoAuth>
        }
      />

      {/* Protected routes - require authentication */}
      {user ? (
        <>
          {/* Dashboard with nested routes for dialogs and sections */}
          <Route path="/" element={<Dashboard />}>
            <Route path="settings/password" element={<PasswordChangeDialog />} />
            <Route path="settings/admin" element={<AdminSettingsDialog />} />
            <Route path="whats-new" element={<WhatsNewDialog />} />
          </Route>

          {/* Section routes with wildcard support for sub-routes */}
          <Route path="/assets/*" element={<Dashboard />} />
          <Route path="/customers/*" element={<Dashboard />} />
          <Route path="/systems/*" element={<Dashboard />} />
          <Route path="/projects/*" element={<Dashboard />} />
          <Route path="/orders/*" element={<Dashboard />} />
          <Route path="/filling/*" element={<Dashboard />} />
          <Route path="/alerts/*" element={<Dashboard />} />
          <Route path="/dashboards/*" element={<Dashboard />} />
          <Route path="/planner/*" element={<Dashboard />} />
          <Route path="/connections/*" element={<Dashboard />} />

          {/* Catch-all: redirect invalid routes to home */}
          <Route path="/deployments/*" element={<Navigate to="/projects" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
      )}
    </Routes>
  )
}

export default Routing
